namespace $ {

	/** Start independent native reads before suspending the whole module graph. */
	export class $shm_hitalama_map_component_preparation extends $mol_object {

		@ $mol_mem_key
		read( root: $shm_hitalama_map_widget_entity_custom ) {
			let pending: PromiseLike< unknown > | null = null
			const visited = new Set< string >
			const attempt = ( task: ()=> unknown )=> this.$.$mol_error_fence(
				()=> { task(); return true },
				error => error,
				promise => { pending ??= promise; return false },
			)
			const visit = ( definition: $shm_hitalama_map_widget_entity_custom )=> {
				const id = definition.link().str
				if( visited.has( id ) ) return
				visited.add( id )
				if( !attempt( ()=> this.$.$shm_hitalama_map_component_ready.read( definition ) ) ) return
				for( const kind of [ 'tree', 'logic', 'style' ] as const ) attempt( ()=> {
					const source = definition.source_link( kind )
					if( source ) this.$.$shm_hitalama_map_component_ready.read( source )
					definition.source_text( kind )
				} )
				attempt( ()=> {
					for( const dependency of definition.dependencies() ) visit( this.$.$giper_baza_glob.Pawn(
						new this.$.$giper_baza_link( dependency.link ), this.$.$shm_hitalama_map_widget_entity_custom,
					) )
				} )
			}
			visit( root )
			// Keep every readiness channel subscribed. No Promise.all, timers or
			// manual render: native reactive invalidation resumes the graph.
			if( pending ) $mol_fail_hidden( pending )
			return true
		}

	}

}
